import React, { useEffect } from "react";

export const FxTitle = props => {

  const { attr } = props;
  const inputType = props.inputType === undefined ? "" : props.inputType;

  // console.log('*** FxLabel ***', attr);

  return (
    <label className={"FxTitle" + inputType + (attr.isNullable() ? "" : " NotNull")} >{attr.attrUiTxt}</label>
  );

}
